import {$authHost} from "../../../http";
import {v4 as uuidv4} from "uuid";
import {getData, getOneData} from "../template/get";
import {
    CLIENT_REQUEST_ONE_ERROR,
    CLIENT_REQUEST_ONE_REQUEST,
    CLIENT_REQUEST_ONE_SUCCESS,
    CLIENT_REQUEST_REQUEST_ERROR,
    CLIENT_REQUEST_REQUEST_REQUEST,
    CLIENT_REQUEST_REQUEST_SUCCESS
} from "../../constants/clientRequest/clientRequestConstants";

export const getClientRequest = (page, size, args, nonGlobal) => async (dispatch) => {
    return await dispatch(getData(CLIENT_REQUEST_REQUEST_REQUEST, CLIENT_REQUEST_REQUEST_SUCCESS, CLIENT_REQUEST_REQUEST_ERROR, 'clientRequest', true, page, null, null, true, size, args, nonGlobal))
};

export const getOneClientRequest = (id) => async (dispatch) => {
    try {
        dispatch({
            type: CLIENT_REQUEST_ONE_REQUEST,
        });
        
        let result = null;
        const queryBody = {
            paging: {
                skip: 0,
                take: 1,
                pageSize: 1,
                pageNumber: 1,
                returnCount: true
            },
            filter: {
                id: {
                    operand1: id,
                    operator: "equals"
                }
            }
        };

        // Способ 1: клиентский endpoint (доступен для клиентов)
        try {
            const { data } = await $authHost.post('/api/v1/area/client/request', queryBody);
            if (data?.result?.length > 0) {
                result = data.result[0];
            } else if (Array.isArray(data) && data.length > 0) {
                result = data.find(r => r.id === +id || r.id === id) || data[0];
            }
        } catch (e) {
            // Клиентский endpoint недоступен — пробуем админский
        }

        // Способ 2: админский endpoint (доступен для админов/маркетологов)
        if (!result) {
            try {
                const { data } = await $authHost.post('api/v1/clientRequest/query', queryBody);
                if (data?.result?.length > 0) {
                    result = data.result[0];
                }
            } catch (e) {
                // Оба endpoint недоступны
            }
        }
        
        dispatch({
            type: CLIENT_REQUEST_ONE_SUCCESS,
            payload: result
        });
        
        return result;
    } catch (error) {
        dispatch({
            type: CLIENT_REQUEST_ONE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};

export const addClientRequest = (specifications, clientId, cityId, specificationsSummary, filialId) => async (dispatch) => {
    try {
        const requestBody = {
            specifications: [
                ...specifications
            ],
            number: uuidv4(),
            createdAt: new Date(),
            stateId: 1,
            clientId,
            specificationsSummary,
            ...(filialId && {filialId}),
            ...(cityId && {cityId})
        }
        console.log("addClientRequest отправляем:", JSON.stringify(requestBody, null, 2))
        await $authHost.post(`api/v1/clientRequest`, requestBody);
    } catch (error) {
        console.error("Ошибка при создании заявки:", error?.response?.data || error.message)
        throw error
    }
};


export const deleteClientRequest = (id) => async (dispatch) => {
    try {

        await $authHost.delete(
            "/api/v1/clientRequest",
            {
                data: {
                    id
                }
            },
        );
        dispatch(getClientRequest())
    } catch (error) {
        dispatch({
            type: CLIENT_REQUEST_REQUEST_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw new Error()
    }
}
